//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useState, useEffect, useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";

// custom pages
import useForm from "helpers/useForm";
import { signupDetailsValidate } from "helpers/validateRules/auth";
import auth from "apis/auth/auth";
import SignupParent from "components/AuthPages/SignupParent";
import Grid from "@material-ui/core/Grid";
import { signUpDetailsStyles } from "./styles";

// material-ui
import {
  withStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import MenuItem from "@material-ui/core/MenuItem";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import Checkbox from '@material-ui/core/Checkbox';
// material-ui icons
import ArrowBackOutlinedIcon from "@material-ui/icons/ArrowBackOutlined";
import VisibilityOffOutlinedIcon from "@material-ui/icons/VisibilityOffOutlined";
import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";
import CheckCircleOutlinedIcon from "@material-ui/icons/CheckCircleOutlined";

// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#fff",
    },
    "& .MuiInputBase-input": {
      color: "#fff",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#fff!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#fff!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#fff",
      },
      "&:hover fieldset": {
        borderColor: "#fff",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#fff",
      },
    },
  },
})(TextField);

const GlobalCss = withStyles({
  "@global": {
    ".MuiSelect-icon": {
      color: "#fff",
    },
  },
})(() => null);

const formLabelsTheme = createMuiTheme({
  overrides: {
    MuiFormLabel: {
      asterisk: {
        color: "#db3131",
        "&$error": {
          color: "#db3131",
        },
      },
    },
  },
  palette: {
    primary: {
      main: "#000000",
    },
  },
});

const toastCss = {
  position: "top-center",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: false,
  draggable: true,
  progress: undefined,
};

const initialValues = {
  firstName: "",
  lastName: "",
  email: "",
  role: "",
  role_details: {},
  password: "",
};

const roles = [
  {
    role_name: "IT Admin",
    role_id: 10
  },
  {
    role_name: "Marketing Admin",
    role_id: 3
  },
  ,
  {
    role_name: "Observer",
    role_id: 12
  },
];

const orgList = [
  {
    org_name: "Henry Schein Dental",
    org_id: 1
  },
  {
    org_name: "Henry Schein Ortho",
    org_id: 2
  },
];

export default function SignupDetails() {
  const history = useHistory();
  const location = useLocation();
  const { signupDetails, getRoles } = auth();

  const classes = signUpDetailsStyles();

  const [states, setstates] = useState({
    showPassword: false,
    disableButton: false,
    roles: [],
  });

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  // roles api func
  const setRoles = async () => {
    const roles = await getRoles("employee");
    setStates({ roles: roles });
  };

  // useEffect(() => {
  //   setRoles();
  //   if (
  //     location.state &&
  //     location.state.emailResponse &&
  //     (location.state.page == "signup" ||
  //       location.state.page == "resetpassword")
  //   ) {
  //     return;
  //   }
  //   history.goBack();
  // }, []);

  // handling inputs
  const { values, errors, handleSubmit, handleChange, setUpdateValue } =
    useForm(initialValues, handleSignupDetails, signupDetailsValidate);

  // signup api func
  async function handleSignupDetails() {
    try {
      let emailResponse = location.state.emailResponse;
      let obj = {
        email: emailResponse.email,
        first_name: values.firstName,
        last_name: values.lastName,
        role: values.role,
        role_details: values.role_details,
        password: values.password,
      };
      let token = location.state.token;
      let res = await signupDetails(obj, token);
      if (res && res.type == "success") {
        toast.success("User requested for approval successfully", toastCss);
        return history.push("/login");
      }
      toast.error(
        res && res.message ? res.message : "something went wrong",
        toastCss
      );
      setStates({ disableButton: false });
    } catch (e) {
      console.log({ e });
      toast.error("something went wrong", toastCss);
    }
  }

  // password validation func
  const passwordValidation = (password) => {
    let lowerCaseLetters = /[a-z]/g;
    let upperCaseLetters = /[A-Z]/g;
    let numbers = /[0-9]/g;
    let specialLetters = /[!@#$%^&*(),.?":{}|<>]/g;
    if (lowerCaseLetters.test(password)) {
      setStates({ lowerCase: true });
    } else setStates({ lowerCase: false });
    if (upperCaseLetters.test(password)) {
      setStates({ upperCase: true });
    } else {
      setStates({ upperCase: false });
    }
    if (numbers.test(password)) {
      setStates({ number: true });
    } else {
      setStates({ number: false });
    }
    if (password.length >= 8) {
      setStates({ length: true });
    } else {
      setStates({ length: false });
    }
    if (specialLetters.test(password)) {
      setStates({ special: true });
    } else {
      setStates({ special: false });
    }
  };

  return (
    <SignupParent>
      <GlobalCss />
      <div className={classes.userText}>
        <ArrowBackOutlinedIcon
          className={classes.backArrowIcon}
          onClick={() => {
            history.goBack();
          }}
        />
        &nbsp;Signup
      </div>
      <div className={classes.inputMainDiv}>
        <ThemeProvider theme={formLabelsTheme}>
          <Grid className={classes.inputRow}>
            <Grid xs={12} sm={12} lg={12}>
              <CssTextField
                id="firstName"
                label="First Name"
                type={"text"}
                required
                fullWidth={true}
                autoComplete="off"
                onfocus="this.removeAttribute('readonly')"
                value={values.firstName}
                onChange={(e) => {
                  handleChange({ name: "firstName", value: e.target.value });
                }}
              />
            </Grid>
            {errors.firstName && (
              <span className="error">{errors.firstName}</span>
            )}
          </Grid>
          <Grid className={classes.inputRow}>
            <Grid xs={12} sm={12} lg={12}>
              <CssTextField
                id="lastName"
                label="Last Name"
                type={"text"}
                required
                fullWidth={true}
                autoComplete="off"
                onfocus="this.removeAttribute('readonly')"
                value={values.lastName}
                onChange={(e) => {
                  handleChange({ name: "lastName", value: e.target.value });
                }}
              />
            </Grid>
            {errors.lastName && (
              <span className="error">{errors.lastName}</span>
            )}
          </Grid>
          <Grid className={classes.inputRow}>
            <Grid xs={12} sm={12} lg={12}>
              <CssTextField
                id="email"
                label="Email"
                type={"email"}
                required
                fullWidth={true}
                autoComplete="off"
                onfocus="this.removeAttribute('readonly')"
                value={values.email}
                onChange={(e) => {
                  handleChange({ name: "email", value: e.target.value });
                }}
              />
            </Grid>
            {errors.lastName && (
              <span className="error">{errors.lastName}</span>
            )}
          </Grid>
          <Grid className={classes.inputRow}>
            <Grid xs={12} sm={12} lg={12}>
              <CssTextField
                id="role"
                select
                required
                label="Role"
                className={classes.roleInput}
                value={values.role}
                autoComplete="off"
                onfocus="this.removeAttribute('readonly')"
                onClick={(e) => {
                  handleChange({ name: "role", value: e.target.value });
                }}
              >
                {roles?.map((r, i) => (
                  <MenuItem
                    value={r.role_id}
                    key={i}
                    onClick={(e) => {
                      handleChange({
                        name: "role_details",
                        value: { role_name: r.role_name, role_id: r.role_id },
                      });
                    }}
                  >
                    {r.role_name}
                  </MenuItem>
                ))}
              </CssTextField>
            </Grid>
            {errors.role && <span className="error">{errors.role}</span>}
          </Grid>
          <Grid className={classes.inputRow}>
            <Grid xs={12} sm={12} lg={12}>
              <CssTextField
                id="org"
                select
                required
                label="Organization"
                className={classes.roleInput}
                value={values.org}
                autoComplete="off"
                onfocus="this.removeAttribute('readonly')"
                onClick={(e) => {
                  handleChange({ name: "org", value: e.target.value });
                }}
              >
                {orgList?.map((r, i) => (
                  <MenuItem
                    value={r.org_id}
                    key={i}
                    onClick={(e) => {
                      handleChange({
                        name: "role_details",
                        value: { org_name: r.org_name, org_id: r.org_id },
                      });
                    }}
                  >
                    {r.org_name}
                  </MenuItem>
                ))}
              </CssTextField>
            </Grid>
            {errors.role && <span className="error">{errors.org}</span>}
          </Grid>
          <Grid className={classes.inputRow}>
            <Grid xs={12} sm={12} lg={12}>
              <CssTextField
                id="pwd"
                label="Password"
                type={states.showPassword ? "text" : "password"}
                required
                fullWidth={true}
                autoComplete="new-password"
                onfocus="this.removeAttribute('readonly')"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => {
                          setStates({ showPassword: !states.showPassword });
                        }}
                        edge="end"
                      >
                        {states.showPassword ? (
                          <VisibilityOutlinedIcon
                            className={classes.passwordInputIcon}
                          />
                        ) : (
                          <VisibilityOffOutlinedIcon
                            className={classes.passwordInputIcon}
                          />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                value={values.password}
                onChange={(e) => {
                  handleChange({ name: "password", value: e.target.value });
                  passwordValidation(e.target.value);
                }}
              />
            </Grid>
            {errors.password && (
              <span className="error">{errors.password}</span>
            )}
          </Grid>
          {/* <Grid className={classes.inputRow}>
            <Grid
              xs={12}
              sm={6}
              lg={6}
              style={{ color: states.lowerCase ? "#FFFF00" : "#000" }}
            >
              <CheckCircleOutlinedIcon
                className={classes.passwordValidateIcon}
              />{" "}
              One lowercase character
            </Grid>
            <Grid
              xs={12}
              sm={6}
              lg={6}
              style={{ color: states.length ? "#FFFF00" : "#000" }}
            >
              <CheckCircleOutlinedIcon
                className={classes.passwordValidateIcon}
              />{" "}
              8 characters minimum
            </Grid>
            <Grid
              xs={12}
              sm={6}
              lg={6}
              style={{ color: states.upperCase ? "#FFFF00" : "#000" }}
            >
              <CheckCircleOutlinedIcon
                className={classes.passwordValidateIcon}
              />{" "}
              One uppercase character
            </Grid>
            <Grid
              xs={12}
              sm={6}
              lg={6}
              style={{ color: states.special ? "#FFFF00" : "#000" }}
            >
              <CheckCircleOutlinedIcon
                className={classes.passwordValidateIcon}
              />{" "}
              One special character
            </Grid>
            <Grid
              xs={12}
              sm={6}
              lg={6}
              style={{ color: states.number ? "#FFFF00" : "#000" }}
            >
              <CheckCircleOutlinedIcon
                className={classes.passwordValidateIcon}
              />{" "}
              One number
            </Grid>
          </Grid> */}
        </ThemeProvider>
      </div>
      <div className={classes.termsTextParent}>
        <Checkbox />
        <span className={classes.termsText}>
          I agree to all the terms and conditions
        </span>
      </div>
      <div className={classes.btnDiv}>
        <Button
          variant="contained"
          className={classes.btn}
          onClick={() => {
            handleSubmit();
            setStates({ disableButton: true });
          }}
        >
          Proceed
        </Button>
      </div>
    </SignupParent>
  );
}
